export default __webpack_public_path__ + "static/media/doc.5210cf4c.svg";